/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./twinMapMarkerColorPickerMenu.vue?vue&type=template&id=edf9c5bc"
import script from "./twinMapMarkerColorPickerMenu.vue?vue&type=script&lang=js"
export * from "./twinMapMarkerColorPickerMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports